export default __webpack_public_path__ + "static/media/regulatory--no-left-turn--g5.c53c6486.png";